import React from "react";
import logo from "./computer.png";

import "./about.css";
export const About = () => {
  return (
    <div>
      <div className="aboutName">About</div>
      <div className="about">
        <div>
          <div>
            ⚡ I enjoy developing websites and a keen interest in solving
            problems and coming up with effective solutions.
          </div>
          <div>
            ⚡ Enjoy building responsive websites (frontend) using ReactJS,
            Bootstrap etc.
          </div>
          <div>
            ⚡ Experience in working on multiple Backened platforms like Node,
            Express, MongoDB, Postman.
          </div>
        </div>
        <div>
          <img src={logo} alt="" />
        </div>
      </div>
    </div>
  );
};
